import { render, staticRenderFns } from "./PrayerTimes.vue?vue&type=template&id=6996f97f&"
import script from "./PrayerTimes.vue?vue&type=script&lang=js&"
export * from "./PrayerTimes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports